import { useEffect } from "react";
import { useLocalStorage, useMediaQuery, useReadLocalStorage, useUpdateEffect } from "usehooks-ts";

const COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";

interface UseDarkModeOutput {
  isDarkMode: boolean;
  toggle: () => void;
  enable: () => void;
  disable: () => void;
}

function useDarkMode(): UseDarkModeOutput {
  const isDarkOS = useMediaQuery(COLOR_SCHEME_QUERY);
  const defaultValue:boolean | null = useReadLocalStorage(`${import.meta.env.VITE_APP_STORAGE_KEY}-theme-mode`);
  const [isDarkMode, setDarkMode] = useLocalStorage<boolean>(
    `${import.meta.env.VITE_APP_STORAGE_KEY}-theme-mode`,
    defaultValue ?? isDarkOS ?? false
  );

  // Update darkMode if os prefers changes
  useEffect(() => {
    if(defaultValue === null)
      setDarkMode(isDarkOS);
  }, [isDarkOS]);
  return {
    isDarkMode,
    toggle: () => setDarkMode((prev) => !prev),
    enable: () => setDarkMode(true),
    disable: () => setDarkMode(false),
  };
}

export default useDarkMode;
